import React, { ReactElement } from 'react';
import Link from 'next/link';
import { gql, useQuery } from '@apollo/client';
import { GetCollectionsListQuery } from '../generated/graphql';
import { HeaderText, PageHeader } from '@components/Text';
import { ContentPadding } from '@components/ContentPadding';
import Layout from '@components/Layout';
import { routes } from '@utils/routes';
import { sortByCommission } from 'logic/commissions';
import { ButtonLink } from '@components/Link';
import { MarkdownText } from '@components/MarkdownText';

export default function Commissions(): ReactElement {
  const { data } = useQuery<GetCollectionsListQuery>(queryCollectionsPage);
  const commissionsList = data?.commisionCollection.items ?? [];
  const collections = data?.collectionCollection.items ?? [];
  const communityProjects = data?.communityProjectsCollection.items ?? [];
  console.log(communityProjects);

  const styles = {
    collectionListItem: 'text-base sm:text-lg font-bold capitalize relative',
  };

  const commissionTiersSection = [...commissionsList]
    .sort(sortByCommission)
    .map((item) => (
      <div className="text-left w-full mb-20" key={item.slug}>
        <Link href={routes.commissionTier(item.slug)} passHref>
          <a>
            <HeaderText as="h3" className="mb-2">
              {item.name} Commission
            </HeaderText>
          </a>
        </Link>
        <div className="text-base w-6/12">
          {item.shortDescription ?? item.description}
        </div>
        <div className="mt-8">
          {collections.reduce((acc, rec) => {
            if (rec.season.commission.slug === item.slug) {
              acc.push(
                <div key={rec.name} className={styles.collectionListItem}>
                  {rec.droptime != null ? (
                    <Link href={routes.collectionDetails(rec.slug)}>
                      <a className={'hover:text-gray-600'}>{rec.name}</a>
                    </Link>
                  ) : (
                    <div className={'text-gray-500'}>{rec.name}</div>
                  )}
                </div>
              );
            }
            return acc;
          }, [])}
        </div>
        <ButtonLink
          className="mt-8"
          href={routes.commissionTier(item.slug)}
          passHref
        >
          <h3 className="font-medium text-white">Learn More</h3>
        </ButtonLink>
      </div>
    ));
  const projectsSection = (
    <div className="text-left w-full mb-20">
      <Link href="/community-projects" passHref>
        <a>
          <HeaderText as="h3" className="mb-2">
            Community Projects
          </HeaderText>
        </a>
      </Link>
      <div className="text-base w-6/12">
        <MarkdownText text={data?.communityProjectsPage.shortDescription} />
      </div>
      <div className="mt-8">
        {communityProjects.map((rec) => (
          <div key={rec.slug} className={styles.collectionListItem}>
            <Link href={routes.communityProjectDetails(rec.slug)}>
              <a className={'hover:text-gray-600'}>{rec.name}</a>
            </Link>
          </div>
        ))}
      </div>
      <ButtonLink className="mt-8" href="/community-projects" passHref>
        <h3 className="font-medium text-white">Learn More</h3>
      </ButtonLink>
    </div>
  );

  return (
    <Layout>
      <ContentPadding>
        <div className="text-left sm:pt-4 justify-around flex flex-wrap">
          <div className="text-left w-full mb-10">
            <PageHeader className="mb-2">Obscura Projects</PageHeader>
            {/* <div className="text-base w-6/12">
              Some supporting copy. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Fames eget eget augue ornare velit. Facilisis
              habitant neque varius dignissim.
            </div> */}
          </div>
          {/* Display curated, magnum, projects, foundry, community */}
          {[
            commissionTiersSection.slice(0, 2),
            projectsSection,
            commissionTiersSection.slice(2),
          ]}
        </div>
      </ContentPadding>
    </Layout>
  );
}

const queryCollectionsPage = gql`
  query GetCollectionsList {
    collectionCollection(order: droptime_ASC) {
      items {
        slug
        name
        projectName
        droptime
        season {
          commission {
            slug
            name
          }
        }
      }
    }
    communityProjectsPage(id: "1PHtHFSvEKSiTTcuHR5GDf") {
      shortDescription
    }
    communityProjectsCollection(order: order_ASC) {
      items {
        name
        slug
      }
    }
    commisionCollection {
      items {
        slug
        name
        shortDescription
        description
      }
    }
  }
`;
